var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "#393939"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.2005 7.80646C15.9405 7.54646 15.5205 7.54646 15.2605 7.80646L12.0005 11.0598L8.74047 7.7998C8.48047 7.5398 8.06047 7.5398 7.80047 7.7998C7.54047 8.0598 7.54047 8.4798 7.80047 8.7398L11.0605 11.9998L7.80047 15.2598C7.54047 15.5198 7.54047 15.9398 7.80047 16.1998C8.06047 16.4598 8.48047 16.4598 8.74047 16.1998L12.0005 12.9398L15.2605 16.1998C15.5205 16.4598 15.9405 16.4598 16.2005 16.1998C16.4605 15.9398 16.4605 15.5198 16.2005 15.2598L12.9405 11.9998L16.2005 8.7398C16.4538 8.48646 16.4538 8.0598 16.2005 7.80646Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.d151161db5fc34f48192747657aab512.svg";
export { ForwardRef as ReactComponent };